import { useUser } from "@accredo/fe-shared/hooks/user.js";
import insurerPolicy from "../../policies/InsurerPolicy.js";

export function useInsurerContactPermissions() {
  const { user } = useUser();

  return {
    canCreate: () => insurerPolicy.updateEmail({ user }),
    canEdit: () => insurerPolicy.updateEmail({ user }),
    canDelete: () => insurerPolicy.updateEmail({ user }),
    canMakeDefault: () => insurerPolicy.updateEmail({ user }),
  };
}
